import React from 'react'
import Rkap from '../Rkap'
import { Link, useLocation, useParams } from 'react-router-dom';
import { PlaylistAddCheckCircle, PlaylistAddCircle } from '@mui/icons-material';

const RkapRealisasi = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Rkap>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/rkap/realisasi/rkap`} className={` sub-menu-item ${split[4] === 'rkap'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle />
                                        </div>
                                        <span>Realisasi Rkap</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/rkap/realisasi/compare`} className={` sub-menu-item ${split[4] === 'compare'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Komparasi Realisasi</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            { children }
        </Rkap>
    )
}

export default RkapRealisasi
